import configHandler from "@/common/config/configHandler";
import parseResumeData from "@/common/resume/parseResumeData";
import initState from "@/components/resume/redux/initState";
import loadFont, { fontFamilyList } from "@/utils/loadFont";

export default (res, templateBodyStr) => {
    let template;
    let resume;
    let resumeData;
    const pagination = JSON.parse(JSON.stringify(initState.pagination));
    const body = JSON.parse(templateBodyStr);
    const data = res.pagesData?.[0];
    const info = res.info ? JSON.parse(res.info) : {};

    {
        resume = {}
        resume.id = data.id;
        resume.name = res.name;
        resume.resumeId = data.resumeId;
        resumeData = JSON.parse(data?.userData);
        parseResumeData(resumeData)
        resume.pageId = data.id;
    } //resume

    {
        template = configHandler(body.html)
        template.linkConfig = body.cssList.map((name) => {
            return {
                href: name, rel: "stylesheet"
            }
        });
        template.id = res.templateId;
        template.originId = res.originId
    } //template


    {
        if (info.openAutoOnePage !== undefined) {
            pagination.openAutoOnePage = info.openAutoOnePage;
        }
        if (info.openAutoPagination !== undefined) {
            pagination.openAutoPagination = info.openAutoPagination;
        }
        if (info.onePageLevel !== undefined) {
            pagination.onePageLevel = info.onePageLevel;
        }
        if (info.defaultThemeIndex !== undefined) {
            resume.defaultThemeIndex = info.defaultThemeIndex;
        }
        if (info.themeIndex !== undefined) {
            resume.themeIndex = info.themeIndex;
        }
        if (info.fontSize !== undefined) {
            resume.fontSize = info.fontSize;
        }
        if (info.pageMargin !== undefined) {
            resume.pageMargin = info.pageMargin;
        }
        if (info.moduleMargin !== undefined) {
            resume.moduleMargin = info.moduleMargin;
        }
        if (info.fontFamily !== undefined) {
            resume.fontFamily = info.fontFamily;
            const font = fontFamilyList.find(i => i.fontFamily === info.fontFamily)
            if (font) {
                loadFont(font)
            }
        }


    }//other

    return {
        template, resume, resumeData, theme: body.theme, pagination
    }
}
